import { useState } from "react";
import api from "../api/client";
import { Alert } from "../components/Ui";

export default function AdminAnnounce() {
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [target, setTarget] = useState("all");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  async function send() {
    if (!subject || !message) return setError("Subject and message are required.");
    if (!window.confirm(`Send this announcement to ${target === "resellers" ? "resellers only" : "ALL users"}?`)) return;
    setBusy(true); setError(null); setResult(null);
    try {
      const { data } = await api.post("/admin/announce", { subject, message, target });
      setResult(`Sent to ${data.sent} users.`);
      setSubject(""); setMessage("");
    } catch (e) { setError(e.message); }
    finally { setBusy(false); }
  }

  return (
    <div style={{ maxWidth: 600 }}>
      <h1>Announcement</h1>
      <p className="muted small" style={{ marginBottom: 20 }}>Send an email to all users or resellers only.</p>

      <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Target</label>
      <select className="input" value={target} onChange={(e) => setTarget(e.target.value)}
        style={{ width: "100%", marginBottom: 16 }}>
        <option value="all">All users</option>
        <option value="resellers">Resellers only</option>
      </select>

      <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Subject</label>
      <input className="input" value={subject} onChange={(e) => setSubject(e.target.value)}
        placeholder="e.g. Maintenance notice, New game added" style={{ width: "100%", marginBottom: 16 }} />

      <label className="muted small" style={{ display: "block", marginBottom: 4 }}>Message (HTML supported)</label>
      <textarea className="input" rows={8} value={message} onChange={(e) => setMessage(e.target.value)}
        placeholder="Write your announcement here..." style={{ width: "100%", resize: "vertical", marginBottom: 16 }} />

      <Alert>{error}</Alert>
      {result && <p style={{ color: "var(--ok)", fontWeight: 700, marginBottom: 12 }}>{result}</p>}

      <button className="btn primary" onClick={send} disabled={busy || !subject || !message}
        style={{ padding: "12px 24px" }}>
        {busy ? "Sending…" : "Send announcement"}
      </button>
    </div>
  );
}
